import { useEffect, useRef } from "react";
import {
    Alert,
    AlertAction,
    AlertDescription,
    AlertTitle,
} from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

interface AppUpdateNoticeProps {
    updateAvailable: boolean;
    forceUpdate: boolean;
    showDismiss?: boolean;
    onRefresh: () => void;
    onForceReload: () => void;
    onDismiss: () => void;
}

export default function AppUpdateNotice({
    updateAvailable,
    forceUpdate,
    showDismiss = true,
    onRefresh,
    onForceReload,
    onDismiss,
}: AppUpdateNoticeProps) {
    const forceReloadStarted = useRef(false);
    useEffect(() => {
        if (!forceUpdate || forceReloadStarted.current) return;
        forceReloadStarted.current = true;
        onForceReload();
    }, [forceUpdate, onForceReload]);

    if (!updateAvailable || forceUpdate) {
        return null;
    }

    return (
        <div className="pointer-events-none fixed inset-x-0 bottom-4 z-150 flex justify-center px-4">
            <Alert
                variant="destructive"
                className="pointer-events-auto max-w-md shadow-md"
            >
                <AlertTitle>A new version is available</AlertTitle>
                <AlertDescription>
                    Refresh to get the latest updates.
                </AlertDescription>
                <AlertAction className="flex gap-1">
                    {showDismiss && (
                        <Button size="xs" variant="ghost" onClick={onDismiss}>
                            Close
                        </Button>
                    )}
                    <Button
                        size="xs"
                        variant="destructive"
                        className="bg-destructive text-white hover:bg-destructive-700"
                        onClick={onRefresh}
                    >
                        Refresh
                    </Button>
                </AlertAction>
            </Alert>
        </div>
    );
}
